import React from "react";
import { Link, Box, Typography } from "@mui/material";
import { SidebarFooter } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link as RouterLink } from "react-router-dom";

const Footer = ({ isCollapsed }) => {
  return (
    <SidebarFooter
      className="Footer"
      style={{
        width: "100%",
        backgroundColor: "#11192A",
        borderTop: "1px solid rgba(255,255,255,0.15)",
        marginTop: "auto",
        overflowX: "hidden",
      }}
    >
      {isCollapsed ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="5px"
          py="9px"
        >
          <Typography fontSize="0.72rem">
            <Link
              component={RouterLink}
              to="/acknowledgement"
              underline="hover"
              color="inherit"
            >
              Ack.
            </Link>
          </Typography>

          <Typography fontSize="0.72rem">
            <Link
              component={RouterLink}
              to="/imprint"
              underline="hover"
              color="inherit"
            >
              Imp.
            </Link>
          </Typography>

          <Typography fontSize="0.72rem">
            <Link
              href="https://www.ipeg.uni-hannover.de/barrierefreiheit"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="inherit"
            >
              Acc.
            </Link>
          </Typography>

          <Typography fontSize="0.72rem">
            <Link
              href="https://www.uni-hannover.de/datenschutzerklaerung/"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="inherit"
            >
              Priv.
            </Link>
          </Typography>

          <Typography
            fontSize="0.58rem"
            textAlign="center"
            sx={{ opacity: 0.6, px: "4px" }}
          >
            DFG (442146713)
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            px: 1.2,
            py: 1.1,
            textAlign: "center",
            overflowX: "hidden",
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            <Typography fontSize="0.72rem">
              <Link
                component={RouterLink}
                to="/acknowledgement"
                underline="hover"
                color="inherit"
              >
                Acknowledgement
              </Link>
            </Typography>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap="5px"
            sx={{
              mt: "5px",
              flexWrap: "wrap",
              textAlign: "center",
            }}
          >
            <Typography fontSize="0.72rem">
              <Link
                component={RouterLink}
                to="/imprint"
                underline="hover"
                color="inherit"
              >
                Imprint
              </Link>
            </Typography>

            <Typography fontSize="0.72rem" sx={{ opacity: 0.3 }}>
              ·
            </Typography>

            <Typography fontSize="0.72rem">
              <Link
                href="https://www.ipeg.uni-hannover.de/barrierefreiheit"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="inherit"
              >
                Accessibility
              </Link>
            </Typography>

            <Typography fontSize="0.72rem" sx={{ opacity: 0.3 }}>
              ·
            </Typography>

            <Typography fontSize="0.72rem">
              <Link
                href="https://www.uni-hannover.de/datenschutzerklaerung/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="inherit"
              >
                Privacy Policy
              </Link>
            </Typography>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            flexDirection="column"
            sx={{ mt: "7px", textAlign: "center" }}
          >
            <Typography fontSize="0.66rem">
              This work has been supported by NFDI4ING
            </Typography>

            <Typography fontSize="0.66rem">
              DFG Project Number: 442146713
            </Typography>
          </Box>
        </Box>
      )}
    </SidebarFooter>
  );
};

export default Footer;
